import { useProfilePreview } from "PFApp/use_profile_preview";
import ProfileCard from "PFComponents/profile_card/profile_card";
import { useCurrentAccount } from "PFCore/hooks/queries/account";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useMemo } from "react";

import { useProfileChatIcon } from "./use_profile_chat_icon";

/**
 * @deprecated Use application\components\profile_card
 */
const ProfileCardConnected = (props) => {
  const { data: currentAccount } = useCurrentAccount();
  const {
    data: { custom_types: customTypes }
  } = useMyAccountInfo();

  const { showPreview } = useProfilePreview();

  const { profileResponse, withChat } = props;

  const { icon, handleClick: handleChatClick } = useProfileChatIcon(profileResponse);

  const onClick = () => {
    if (props.onClick) {
      onClick();
    }
    const { profile } = props.profileResponse;
    if (profile) {
      showPreview({ id: profile.id, profile });
    }
  };

  const handleIconClick = useMemo(
    () => props.handleIconClick || (withChat ? handleChatClick : null),
    [handleChatClick, withChat, props.handleIconClick]
  );

  const finalIcon = props.icon || (withChat ? icon : null);

  return (
    <ProfileCard
      {...props}
      currentAccount={currentAccount}
      customTypes={customTypes}
      handleClick={onClick}
      icon={finalIcon}
      handleIconClick={handleIconClick}
    />
  );
};

ProfileCardConnected.propTypes = { ...ProfileCard.propTypes, currentProfile: undefined };

export default ProfileCardConnected;
